// ═══════════════════════════════════════════════════════════════════════════
// Estilos compartidos
// Extraído VERBATIM de index.html v0.9.16.
// ═══════════════════════════════════════════════════════════════════════════



export const inputStyle = {
  width: "100%", padding: "10px 12px", background: "#0d0d0d", border: "1px solid #2a2a2a",
  borderRadius: 6, color: "#e8e0d4", fontSize: 14, fontFamily: "inherit", outline: "none",
  boxSizing: "border-box", transition: "border-color 0.2s",
};

export const selectStyle = { ...inputStyle, appearance: "none", cursor: "pointer" };

export const btnPrimary = {
  padding: "12px 24px", background: "linear-gradient(135deg, #c9a96e, #a68532)", border: "none",
  borderRadius: 8, color: "#0a0a0a", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
  transition: "all 0.2s", letterSpacing: 0.5,
};

export const btnSecondary = {
  padding: "10px 20px", background: "transparent", border: "1px solid #333",
  borderRadius: 8, color: "#999", fontSize: 13, cursor: "pointer", fontFamily: "inherit",
  transition: "all 0.2s",
};
